import { createContext, useContext, useState } from 'react';

export type Language = 'en' | 'es';

interface LanguageContextValue {
  lang: Language;
  setLang: (l: Language) => void;
}

export const LanguageContext = createContext<LanguageContextValue>({
  lang: 'en',
  setLang: () => undefined,
});

export function useLanguage(): LanguageContextValue {
  return useContext(LanguageContext);
}

export function useLanguageState(): LanguageContextValue {
  const [lang, setLang] = useState<Language>('en');
  return { lang, setLang };
}
